module.exports = __webpack_public_path__ + "/img/SOJ-Labeled-DYRaZK.svg";